<template>
  <div class="tab-container">
    <div :class="['tab-container__nav', navClass]">
      <ul class="tab-container__nav__items">
        <li
          v-for="(tab, tabIndex) in tabsIndexed"
          :key="tab.key"
          class="tab-container__nav__item"
        >
          <button
            type="button"
            :disabled="messageLength <= 0 && tab.key == 'notifications'"
            @click="
              () => {
                if (!showNavIndices || tabsVisited.indexOf(tab.key) != -1)
                  showTab(tab.key);
              }
            "
            :class="
              Object.assign({}, buttonClass, {
                active: tab.key == activeTab,
                visited: tabsVisited.indexOf(tab.key) != -1,
                'disabled-notification':
                  messageLength <= 0 && tab.key == 'notifications',
              })
            "
          >
            <span
              v-if="showNavIndices"
              class="tab-container__nav__item__index"
              >{{ tabIndex + 1 }}</span
            >
            <span class="tab-container__nav__item__label">{{ tab.label }}</span>
          </button>
        </li>
      </ul>
    </div>

    <div
      :class="`tab-container__body tab-container__body--${activeTab}`"
      :key="activeTab"
    >
      <slot
        :name="activeTab"
        :showTab="showTab"
        :showNext="showNext"
        :showPrev="showPrev"
      ></slot>
    </div>
  </div>
</template>

<script>
import { parseJSON } from "date-fns";
export default {
  props: {
    tabs: {
      type: Object,
      required: true,
    },
    initialTab: {
      type: String,
      required: true,
    },
    navClass: {
      type: String,
    },
    buttonClass: {
      type: Object,
      default: () => {
        return {};
      },
    },
    showNavIndices: {
      type: Boolean,
      default: false,
    },
    beforeSwitch: {
      type: Function,
    },
    onSwitch: {
      type: Function,
    },
    jobnew: {
      type: String,
    },
    jobmsg: {
      type: String,
    },
  },
  computed: {
    tabsIndexed() {
      let tabsIndexed = [];

      Object.keys(this.tabsData).forEach((tabKey) => {
        if (tabKey in this.$slots || tabKey in this.$scopedSlots) {
          tabsIndexed.push({ key: tabKey, label: this.tabsData[tabKey] });
        }
      });

      return tabsIndexed;
    },
  },
  mounted() {
    if (this.jobmsg) {
      this.messageLength = JSON.parse(this.jobmsg).messages_technician
        ? JSON.parse(this.jobmsg).messages_technician.length
        : null;
    }
  },
  data() {
    return {
      activeTab: this.initialTab,
      tabsData: this.tabs,
      tabsVisited: [],
      messageLength: null,
    };
  },
  watch: {
    initialTab: function (newTab) {
      this.tabsVisited.push(this.activeTab);
      this.activeTab = newTab;
    },
  },
  methods: {
    async showTab(keyOrIndex) {
      let key = keyOrIndex;
      let setTab = true;

      if (typeof keyOrIndex == "number") {
        let tabsIndexed = this.tabsIndexed;

        if (keyOrIndex > tabsIndexed.length - 1) {
          keyOrIndex = 0;
        }
        if (keyOrIndex < 0) {
          keyOrIndex = tabsIndexed.length - 1;
        }

        key = tabsIndexed[keyOrIndex].key;
      }

      if (this.beforeSwitch) {
        const result = await this.beforeSwitch(key);
        if (result === false) {
          return false;
        }
      }

      this.tabsVisited.push(this.activeTab);

      if (this.onSwitch) {
        setTab = await this.onSwitch(key);
      }

      if (setTab) {
        this.activeTab = key;

        Vue.nextTick(() => {
          this.$emit("switched", this);
        });
      }

      window.scrollTo(0, 0);
    },
    showNext() {
      let currentIndex = this.tabsIndexed.findIndex(
        (t) => t.key === this.activeTab
      );

      this.showTab(currentIndex + 1);
    },
    showPrev() {
      let currentIndex = this.tabsIndexed.findIndex(
        (t) => t.key === this.activeTab
      );

      this.showTab(currentIndex - 1);
    },
  },
};
</script>
<style lang="scss">
.disabled-notification {
  opacity: 0.7;
  &:hover {
    border-color: #7d7d7d !important;
  }
}
</style>